import { FilterDataPointMetadataValue, FilterDataPointString } from '@/api/generatedApi';
import { SelectedFilters } from '@/components/FilterData/types';
import { Filter } from './Filter';

type FilterValue = string | number | boolean | undefined;

export const MetadataFilter = ({
  filterName,
  filterData,
  selectedFilters,
  isStale,
  onFilterChange,
  readonly,
}: {
  filterName: string;
  filterData: (FilterDataPointString | FilterDataPointMetadataValue)[];
  selectedFilters: SelectedFilters;
  isStale?: boolean;
  onFilterChange: (filterName: string, filterValue: FilterValue) => void;
  readonly?: boolean;
}) => {
  const selectedFilterData =
    filterName in selectedFilters.metadata
      ? {
          filter:
            typeof selectedFilters.metadata[filterName] === 'object'
              ? JSON.stringify(selectedFilters.metadata[filterName])
              : selectedFilters.metadata[filterName],
          count: 0,
        }
      : undefined;

  return (
    <Filter
      config={{
        filterName,
        filterData,
        selectedFilterData,
        enableMultiSelect: true,
        onRemove: () => onFilterChange(filterName, void 0),
      }}
      isStale={isStale}
      onFilterChange={onFilterChange}
      readonly={readonly}
    />
  );
};
